import { IDB_trainingCompletions } from '../IDB/IDB.dexie'

export async function Training_markAsCompleted(trainingId: number): Promise<void> {
    await IDB_trainingCompletions().put({ id: trainingId, isComplete: true }, trainingId)
}
